module.exports = __webpack_public_path__ + "static/media/product-evening-photo.d7bb2b91.svg";